export const getOrders = (payload?: { page?: number, search?: string, status: "NEW" | "PROCESSED" }) => ({
    type: "@saga/GET_ORDERS",
    payload
});